import React, { useContext } from "react";

const PublicContext = React.createContext(false);

export const PublicProvider = ({ children }) => (
  <PublicContext.Provider value={true}>{children}</PublicContext.Provider>
);

export const useIsPublic = () => useContext(PublicContext);

export default PublicContext;
